<script>
export default {
  props: {
    recipient: { type: Object, required: true },
  },
}
</script>

<template>
  <div class="d-flex align-items-center recipient">
    <div>
      <div> {{recipient.name}} </div>
      <div class="small text-muted"> {{recipient.email}} </div>
    </div>

    <div class="ml-auto">
      <confirm-click>
        <api-button
          method="delete"
          :url="`v1/tenant/configuration/admin-recipient/${recipient.id}`"
          class="btn btn-outline-secondary delete-button"
          @executed="$emit('deleted', $event)">
          <i class="fa fa-trash-o"></i>
        </api-button>
      </confirm-click>
    </div>
  </div>
</template>

<style scoped>
.delete-button {
  opacity: 0.3;
}
.recipient:hover .delete-button {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/tenant/components/TenantAdminRecipient.vue